import React, { useCallback, useState, useMemo } from 'react';

import { ListPagination } from '../../core/components/list/ListPagination';
import Empty from '../../core/components/list/Empty';
import BulkActionDeleteButton from '../../core/components/BulkActionDeleteButton';
import AddFunds from './AddFunds';

import { Datagrid, TextField, List } from 'react-admin';

const FundRelationsEmpty = props => {
  const {
    hasEditFundTermRelationPermission,
    handleChange,
    fundTermId,
    ids
  } = props;
  return (
    <Empty
      emptyText="There are no related Funds to be displayed"
      buttons={
        hasEditFundTermRelationPermission && ids && ids.length < 1
          ? [
              <AddFunds
                fundTermId={fundTermId}
                onChange={handleChange}
                key="addFund"
                emptyComponent={true}
              />
            ]
          : []
      }
      title="Related Funds"
    />
  );
};

const FundTermsRelations = ({ id: fundTermId, permissions = [], ...rest }) => {
  const { hasList, hasShow, hasEdit, ...datagridProps } = rest;
  const [version, setVersion] = useState(0);

  const hasEditFundTermRelationPermission = useMemo(() => {
    return permissions.includes('AUTH_WRITE_FUND_TERM_AND_CONDITION');
  }, [permissions]);

  // We store a version in the state to be able to refrehs the list on adding funds
  const handleChange = useCallback(
    () => setVersion(version => version + 1),
    []
  );

  return (
    <>
      <List
        key={version}
        style={{ margin: '0px', width: '100%' }}
        pagination={<ListPagination />}
        {...rest}
        resource="fundtermsrelations"
        filter={{ fundTermId }}
        sort={{ field: 'fundTermId', order: 'ASC' }}
        title=" "
        actions={
          hasEditFundTermRelationPermission ? (
            <AddFunds
              fundTermId={fundTermId}
              onChange={handleChange}
              key="addFund"
            />
          ) : null
        }
        bulkActionButtons={
          hasEditFundTermRelationPermission ? <BulkActionDeleteButton /> : null
        }
        empty={
          <FundRelationsEmpty
            fundTermId={fundTermId}
            hasEditFundTermRelationPermission={
              hasEditFundTermRelationPermission
            }
            handleChange={handleChange}
          />
        }
      >
        <Datagrid
          {...datagridProps}
          isRowSelectable={() => hasEditFundTermRelationPermission}
        >
          <TextField source="fundName" label="Fund Name" sortable={false} />
        </Datagrid>
      </List>
    </>
  );
};

export default FundTermsRelations;
